module.exports = __webpack_public_path__ + "img/main_slide1.a1f66d4b.png";